const quickStartStatuses = {
  CREATING: 'CREATING',
  ACTIVE: 'ACTIVE',
  FINISHED: 'FINISHED',
}

export { quickStartStatuses }
